"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SearchType;
(function (SearchType) {
    SearchType["city"] = "city";
    SearchType["street"] = "street";
    SearchType["house"] = "house";
    SearchType["object"] = "object";
})(SearchType = exports.SearchType || (exports.SearchType = {}));
//# sourceMappingURL=types.js.map